import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex: 1;

  width: 100%;

  ${({ theme }) => {
    const bgc = theme.colors.surface.interactiveDefault;
    return theme.media.laptop`  
      justify-content: center;
      background-color: ${bgc as unknown as TemplateStringsArray};
    `;
  }};
`;

export const JustifiedContent = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
  min-height: 100%;
  max-width: 110rem;

  padding-bottom: 11rem;

  ${({ theme }) => theme.media.tablet`
    justify-content: center;

    padding: 2rem 1rem 5rem;
  `};

  ${({ theme }) => theme.media.laptop`
    padding: 2rem 2.8rem 5rem;
  `};
`;
